import * as yup from 'yup'

import {
  npiNumberValidator,
  phoneNumberValidator,
  ssnNumberValidator,
  zipCodeValidator,
} from '@surglogs-app/util'

export const accountSettingsFormValidator = () =>
  yup
    .object({
      first_name: yup.string().trim().required('isRequired'),
      last_name: yup.string().trim().required('isRequired'),
      middle_name: yup.string().trim().optional(),
      other_names: yup.string().trim().optional(),
      ssn: ssnNumberValidator,
      npi: npiNumberValidator,
      cell_number: phoneNumberValidator,
      daytime_number: phoneNumberValidator,
      title: yup.string().trim().required('isRequired'),
      address: yup.object({
        zip_code: zipCodeValidator,
      }),
    })
    .required()
